/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from 'zod'
import { acceptInviteRequestV4Schema } from './acceptInviteRequestV4Schema'
import { acceptInviteResponseV4ApiResponseObjectV4Schema } from './acceptInviteResponseV4ApiResponseObjectV4Schema'
import { apiResponseV4Schema } from './apiResponseV4Schema'

export const invitesAcceptStatus200Schema =
  acceptInviteResponseV4ApiResponseObjectV4Schema.describe(
    'Typed variant of EP.Models.ViewModels.ApiResponseObjectV4, used in `[ProducesResponseType]` so Swagger renders\r\nthe real `result` schema instead of the bare `object` (which the UI shows as `"string"`).\r\nWire shape is identical to the untyped envelope — this only carries the type for the schema generator.'
  )

export const invitesAcceptStatus400Schema = apiResponseV4Schema.describe(
  'V4 response envelope — same contract as the legacy EP.Models.ViewModels.ApiResponse minus the dead\r\n`planNeeded` field. V4 endpoints must never expose `planNeeded`; legacy endpoints keep\r\nthe old envelope untouched.'
)

export const invitesAcceptResponseSchema = invitesAcceptStatus200Schema

export const invitesAcceptErrorSchema = invitesAcceptStatus400Schema

export const invitesAcceptBodySchemaJsonPatchJson = acceptInviteRequestV4Schema
  .optional()
  .describe('Token from the link, the chosen password twice, name, lastname and optional phone.')

export const invitesAcceptBodySchemaJson = acceptInviteRequestV4Schema
  .optional()
  .describe('Token from the link, the chosen password twice, name, lastname and optional phone.')

export const invitesAcceptBodySchemaJson2 = acceptInviteRequestV4Schema
  .optional()
  .describe('Token from the link, the chosen password twice, name, lastname and optional phone.')

export const invitesAcceptBodySchemaJson3 = acceptInviteRequestV4Schema
  .optional()
  .describe('Token from the link, the chosen password twice, name, lastname and optional phone.')

export const invitesAcceptBodySchema = z.union([
  invitesAcceptBodySchemaJsonPatchJson,
  invitesAcceptBodySchemaJson,
  invitesAcceptBodySchemaJson2,
  invitesAcceptBodySchemaJson3,
])
